export default "__VITE_ASSET__e1766056__"